/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSupplierOrganizationDto,
  SupplierOrganizationDto,
  SupplierOrganizationsResponseDto,
  UpdateSupplierOrganizationDto,
} from '../models/index';
import {
    CreateSupplierOrganizationDtoFromJSON,
    CreateSupplierOrganizationDtoToJSON,
    SupplierOrganizationDtoFromJSON,
    SupplierOrganizationDtoToJSON,
    SupplierOrganizationsResponseDtoFromJSON,
    SupplierOrganizationsResponseDtoToJSON,
    UpdateSupplierOrganizationDtoFromJSON,
    UpdateSupplierOrganizationDtoToJSON,
} from '../models/index';

export interface CreateSupplierOrganizationRequest {
    createSupplierOrganizationDto: CreateSupplierOrganizationDto;
}

export interface DeleteSupplierOrganizationByIdRequest {
    id: number;
}

export interface GetAllSupplierOrganizationsRequest {
    page: number;
    query?: string;
    startDate?: string;
    endDate?: string;
    disabled?: boolean;
    orderBy?: Array<string>;
    pageSize?: number;
}

export interface GetSupplierOrganizationByIdRequest {
    id: number;
}

export interface UpdateSupplierOrganizationRequest {
    id: number;
    updateSupplierOrganizationDto: UpdateSupplierOrganizationDto;
}

/**
 * 
 */
export class SupplierOrganizationServiceApi extends runtime.BaseAPI {

    /**
     * Creates supplier organization in database with optional suppliers creation
     */
    async createSupplierOrganizationRaw(requestParameters: CreateSupplierOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierOrganizationDto>> {
        if (requestParameters['createSupplierOrganizationDto'] == null) {
            throw new runtime.RequiredError(
                'createSupplierOrganizationDto',
                'Required parameter "createSupplierOrganizationDto" was null or undefined when calling createSupplierOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organization`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSupplierOrganizationDtoToJSON(requestParameters['createSupplierOrganizationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierOrganizationDtoFromJSON(jsonValue));
    }

    /**
     * Creates supplier organization in database with optional suppliers creation
     */
    async createSupplierOrganization(requestParameters: CreateSupplierOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierOrganizationDto> {
        const response = await this.createSupplierOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes supplier organization by ID
     */
    async deleteSupplierOrganizationByIdRaw(requestParameters: DeleteSupplierOrganizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierOrganizationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSupplierOrganizationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierOrganizationDtoFromJSON(jsonValue));
    }

    /**
     * Deletes supplier organization by ID
     */
    async deleteSupplierOrganizationById(requestParameters: DeleteSupplierOrganizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierOrganizationDto> {
        const response = await this.deleteSupplierOrganizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all supplier organizations with optional filtering
     */
    async getAllSupplierOrganizationsRaw(requestParameters: GetAllSupplierOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierOrganizationsResponseDto>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getAllSupplierOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['disabled'] != null) {
            queryParameters['disabled'] = requestParameters['disabled'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierOrganizationsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Fetches all supplier organizations with optional filtering
     */
    async getAllSupplierOrganizations(requestParameters: GetAllSupplierOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierOrganizationsResponseDto> {
        const response = await this.getAllSupplierOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets supplier organization by ID
     */
    async getSupplierOrganizationByIdRaw(requestParameters: GetSupplierOrganizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierOrganizationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSupplierOrganizationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierOrganizationDtoFromJSON(jsonValue));
    }

    /**
     * Gets supplier organization by ID
     */
    async getSupplierOrganizationById(requestParameters: GetSupplierOrganizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierOrganizationDto> {
        const response = await this.getSupplierOrganizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates supplier organization in DB
     */
    async updateSupplierOrganizationRaw(requestParameters: UpdateSupplierOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierOrganizationDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSupplierOrganization().'
            );
        }

        if (requestParameters['updateSupplierOrganizationDto'] == null) {
            throw new runtime.RequiredError(
                'updateSupplierOrganizationDto',
                'Required parameter "updateSupplierOrganizationDto" was null or undefined when calling updateSupplierOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier-organization/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplierOrganizationDtoToJSON(requestParameters['updateSupplierOrganizationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierOrganizationDtoFromJSON(jsonValue));
    }

    /**
     * Updates supplier organization in DB
     */
    async updateSupplierOrganization(requestParameters: UpdateSupplierOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierOrganizationDto> {
        const response = await this.updateSupplierOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
